<template>
  <div class="header">
    <!-- 头部区域 -->
    <el-header class="cont_flex">
      <div class="top_head_left">
        <div class="user-info">
          <el-avatar v-if="proxy && proxy.avatar" :src="proxy.avatar" size="medium"></el-avatar>
          <el-avatar v-else size="medium" style="background-color: #409eff;">
            {{ proxy && proxy.real_name ? proxy.real_name.charAt(0) : 'U' }}
          </el-avatar>
          <div class="user-details">
            <div class="user-name">{{proxy?proxy.real_name:'管理员'}}</div>
            <div class="user-role">{{proxy?proxy.role_name:'系统管理员'}}</div>
          </div>
        </div>

        <div class="date-info">
          <div class="date-content">
            <div class="current-date">{{ nowDate }}</div>
            <div class="current-week">{{ nowWeek }}</div>
          </div>
        </div>
      </div>
      <div class="top_head_right">
        <!-- 校园选择 -->
        <!-- <el-dropdown class="margin_right campus-dropdown" @command="getCampusList">
          <el-button type="primary" class="campus-btn">
            <i class="el-icon-location"></i>
            <span class="campus-text">{{ this.campusNow }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in campusList"
              :key="item.id"
              :command="item.id"
            >
              <i class="el-icon-location"></i>
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <!-- 用户操作 -->
        <el-dropdown class="user-dropdown" trigger="click">
          <div class="user-account">
            <div  class="account-btn">
              <div class="account-content">
                <i class="el-icon-user"></i>
                <div class="account-info">
                  <div class="account-name">{{ userName }}</div>
                  <div class="account-status">在线</div>
                </div>
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown" class="user-menu">
            <el-dropdown-item @click.native="userInfo" class="menu-item">
              <i class="el-icon-user-solid"></i>
              <span>用户中心</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="changePassword" class="menu-item">
              <i class="el-icon-lock"></i>
              <span>修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout" class="menu-item logout-item">
              <i class="el-icon-switch-button"></i>
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 修改密码弹框 -->
    <el-dialog
            title="修改密码"
            :visible.sync="dialogPassword"
            width="500px"
            :append-to-body="true"
            custom-class="password-dialog"
            center>
      <div class="dialog-icon">
        <i class="el-icon-lock"></i>
      </div>
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px">
        <el-form-item label="账号" prop="user_name">
          <el-input
                  v-model="pwdForm.user_name"
                  readonly
                  autocomplete="off"
                  placeholder="请输入账号"
                  prefix-icon="el-icon-user">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
                  v-model="pwdForm.password"
                  type="password"
                  autocomplete="off"
                  placeholder="请输入新密码"
                  prefix-icon="el-icon-key"
                  show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input
                  v-model="pwdForm.repassword"
                  type="password"
                  autocomplete="off"
                  placeholder="请再次输入新密码"
                  prefix-icon="el-icon-key"
                  show-password>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdReset_dialogForm('pwdForm')" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="pwdSubmitForm('pwdForm')" class="submit-btn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { hexMD5 } from '../../utils/md5' //引入

  export default {
    name:"HeaderView",
    data(){
      return {
        shop:{},
        nowWeek: "",
        nowDate: "",

        userName: '',

        campusList: [],
        campusNow: "",
        model:'',
        ip: "",

        dialogPassword: false,
        pwdForm: {
          user_name: sessionStorage.getItem('userName'),
          password: '',
          repassword: '',
        },
        pwdRules: {
          password: [
            { required: true, message: "请输入新密码", trigger: "blur" },
            { min: 6, message: "密码长度不能少于6位", trigger: "blur" }
          ],
          repassword: [
            { required: true, message: "请再次输入新密码", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (value !== this.pwdForm.password) {
                  callback(new Error('两次输入的密码不一致'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
        },
      }
    },
    created() {
      this.setNowTimes()
      this.campus()
      this.userName = window.sessionStorage.getItem('userName');
      this.proxy = JSON.parse(sessionStorage.getItem("proxy"));
    },
    methods:{
      campus() {
        if (localStorage.getItem("campus") != null) {
          this.campusNow = localStorage.getItem("campus");
          if (this.campusNow == 1) {
            this.campusNow = "中国";
          }
          if (this.campusNow == 2) {
            this.campusNow = "泰国";
          }
          if (this.campusNow == 3) {
            this.campusNow = "韩国";
          }
        }
        if (this.campusList.length == 0) {
          // this.$axios.get("campus.json").then((res) => {
          //     if (res.status == 200) {
          //     console.log(res.data.campus);
          //     this.campusList = res.data.campus;
          //     } else {
          //     this.$message.error("地区国家获取失败，请联系管理员~");
          //     }
          // });
        }
      },
      getCampusList(command) {
        // this.campusNow = command;
        localStorage.setItem("campus", command);
        this.campus();
        this.$message.success("已切换到" + this.campusNow + "地区");
      },
      //个人信息
      userInfo() {
        this.$router.push("/userInfo");
      },
      //用户退出
      logout() {
        this.$confirm('确定要退出登录吗？', '退出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          customClass: 'logout-confirm'
        }).then(() => {
          this.$message.success('退出成功');
          window.sessionStorage.clear();
          this.$router.push("/login");
        }).catch(() => {
          this.$message.info('已取消退出');
        });
      },

      setNowTimes() {
        //获取当前时间
        let myDate = new Date();
        let wk = myDate.getDay();
        let yy = String(myDate.getFullYear() + "年");
        let mm = myDate.getMonth() + 1 + "月";
        let dd = String(
                myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate() + "日"
        );
        let weeks = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        let week = weeks[wk];
        this.nowDate = yy + "-" + mm + "-" + dd;
        this.nowWeek = week;
      },
      changePassword() {
        this.dialogPassword = true
        // 重置表单数据
        this.$nextTick(() => {
          this.pwdForm.password = '';
          this.pwdForm.repassword = '';
        });
      },
      pwdReset_dialogForm(formName) {
        this.dialogPassword = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      pwdSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const param = {
              id: sessionStorage.getItem('user_id'),
              password: hexMD5(this.pwdForm.password),
              repassword: hexMD5(this.pwdForm.repassword),
              access_token: sessionStorage.getItem('token'),
            }
            this.$axios.proxyUserChangePsw(param).then(res => {
              if(res.code==200){
                this.$message.success(res.msg)
                this.dialogPassword = false
              }
            }).catch(function (error) {
              console.log(error);
            })
          }
        })
      },
    }
  }
</script>

<style scoped>
  .header {
    width: 100%;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  }

  .el-header.cont_flex {
    height: 50px !important;
    border-bottom: 1px solid #f0f0f0;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    box-sizing: border-box;
  }

  /* 左侧区域 */
  .top_head_left {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  /* 用户信息 */
  .user-info {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-radius: 3px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
    transition: all 0.3s ease;
  }

  .user-info:hover {
    background: linear-gradient(135deg, #e4e7ed 0%, #d9dde8 100%);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
  }

  .user-details {
    display: flex;
    flex-direction: column;
  }

  .user-name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
  }

  .user-role {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }

  /* 日期信息 */
  .date-info {
    display: flex;
    align-items: center;
    color: #333333;
  }

  .date-icon {
    font-size: 24px;
    display: flex;
    align-items: center;
  }

  .date-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .current-date {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
  }

  .current-week {
    font-size: 12px;
    opacity: 0.9;
    line-height: 1.4;
  }

  /* 右侧区域 */
  .top_head_right {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  /* 校园选择按钮 */
  .campus-dropdown {
    margin-right: 15px;
  }

  .campus-btn {
    background: linear-gradient(135deg, #67c23a 0%, #5daf34 100%) !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 10px 20px !important;
    box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3) !important;
    transition: all 0.3s ease !important;
  }

  .campus-btn:hover {
    background: linear-gradient(135deg, #5daf34 0%, #529b2e 100%) !important;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(103, 194, 58, 0.4) !important;
  }

  .campus-text {
    margin: 0 8px;
  }

  /* 用户下拉菜单 */
  .user-dropdown {
    margin-left: 15px;
  }

  .account-btn {


    height: auto !important;

    transition: all 0.3s ease !important;
  }



  .account-content {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #333;
  }

  .account-content .el-icon-user {
    font-size: 20px;
  }

  .account-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.4;
  }

  .account-name {
    font-size: 14px;
    font-weight: 500;
  }

  .account-status {
    font-size: 11px;
    opacity: 0.9;
  }

  .account-content .el-icon-arrow-down {
    font-size: 14px;
    opacity: 0.9;
  }

  /* 用户菜单 */
  .user-menu {
    border-radius: 12px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid #ebeef5 !important;
    min-width: 160px !important;
  }

  .user-menu .menu-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;
    transition: all 0.3s ease;
  }

  .user-menu .menu-item:hover {
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%) !important;
    color: #409eff !important;
  }

  .user-menu .menu-item i {
    font-size: 16px;
    width: 20px;
    text-align: center;
  }

  .user-menu .logout-item {
    border-top: 1px solid #ebeef5 !important;
    margin-top: 5px !important;
    padding-top: 12px !important;
  }

  .user-menu .logout-item:hover {
    color: #ff6b6b !important;
  }

  /* 弹窗样式 */
  .password-dialog {
    border-radius: 16px !important;
    overflow: hidden !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  }

  .password-dialog .el-dialog__header {
    background: linear-gradient(135deg, #409eff 0%, #337ecc 100%) !important;
    padding: 20px 30px !important;
    border-bottom: none !important;
  }

  .password-dialog .el-dialog__title {
    color: white !important;
    font-weight: 600 !important;
    font-size: 18px !important;
  }

  .password-dialog .el-dialog__headerbtn .el-dialog__close {
    color: white !important;
  }

  .dialog-icon {
    text-align: center;
    margin-bottom: 20px;
  }

  .dialog-icon i {
    font-size: 48px;
    color: #409eff;
    background: linear-gradient(135deg, #ecf5ff 0%, #d9ecff 100%);
    width: 80px;
    height: 80px;
    line-height: 80px;
    border-radius: 50%;
    display: inline-block;
  }

  .password-dialog .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .password-dialog .el-input__inner {
    border-radius: 8px !important;
    border: 1px solid #dcdfe6 !important;
    transition: all 0.3s ease !important;
  }

  .password-dialog .el-input__inner:focus {
    border-color: #409eff !important;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1) !important;
  }

  .password-dialog .dialog-footer {
    padding: 20px 30px !important;
    text-align: center;
    border-top: 1px solid #ebeef5;
  }

  .cancel-btn {
    background: #f5f7fa !important;
    border: 1px solid #dcdfe6 !important;
    color: #606266 !important;
    border-radius: 8px !important;
    padding: 10px 25px !important;
    transition: all 0.3s ease !important;
  }

  .cancel-btn:hover {
    background: #e4e7ed !important;
    transform: translateY(-2px);
  }

  .submit-btn {
    background: linear-gradient(135deg, #409eff 0%, #337ecc 100%) !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 10px 25px !important;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3) !important;
    transition: all 0.3s ease !important;
  }

  .submit-btn:hover {
    background: linear-gradient(135deg, #337ecc 0%, #2a6bb8 100%) !important;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4) !important;
  }

  /* 退出确认框 */
  .logout-confirm .el-message-box__btns {
    justify-content: center !important;
  }

  .logout-confirm .el-message-box__btns button {
    border-radius: 8px !important;
    padding: 8px 20px !important;
    transition: all 0.3s ease !important;
  }

  /* 响应式设计 */
  @media screen and (max-width: 992px) {
    .el-header.cont_flex {
      padding: 0 20px;
      height: 60px !important;
    }

    .top_head_left {
      gap: 15px;
    }

    .user-info {
      padding: 8px 12px;
    }

    .date-info {
      padding: 8px 15px;
    }

    .account-btn {
      padding: 6px 12px !important;
    }
  }

  @media screen and (max-width: 768px) {
    .el-header.cont_flex {
      padding: 0 15px;
      flex-direction: column;
      height: auto !important;
      padding: 10px 0;
    }

    .top_head_left {
      width: 100%;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .top_head_right {
      width: 100%;
      justify-content: flex-end;
    }

    .user-name {
      font-size: 14px;
    }

    .date-info {
      padding: 6px 12px;
    }

    .current-date {
      font-size: 12px;
    }

    .current-week {
      font-size: 11px;
    }
  }

  @media screen and (max-width: 576px) {
    .top_head_left {
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
    }

    .date-info {
      align-self: flex-end;
    }

    .password-dialog {
      width: 90% !important;
    }
  }
</style>
